export function isChromium() {
  return !!window.chrome && !/Edge\//i.test(navigator.userAgent);
}

export function isFirefox() {
  return /Firefox\//i.test(navigator.userAgent);
}
